import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const uv = {
    jpath: ['spectra', 'uv'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default uv;
//# sourceMappingURL=uv.js.map